import React from "react";
import {
  ICO_BAZAR,
  Research,
  MetaMask,
  Link,
  ICO_HUB,
  ICO_ARTCHAIN,
  ICO_TOKEN,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  icon1,
  icon2,
  icon3,
  hoodie_she,
  hoodie2,
  hoodie3,
  hoodie4,
  hoodie5,
  t_shirt1,
  t_shirt2,
  t_shirt3,
  artwork,
  artwork2,
  artwork3,
  artwork4,
  artwork5,
  artwork6,
} from "../assets";

const artWorksData = [
  {
    id: 1,
    name: "Ocean Waves",
    description: "Description of Ocean Waves",
    artist: "Alice Johnson",
    year: 2018,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1400,
    pricePhysical: 1600,
    tags: ["ocean", "music", "abstract"],
    publishing_data: "2021-05-20",
  },
  {
    id: 2,
    name: "Starry Night",
    description: "Description of Starry Night",
    artist: "Bob Smith",
    year: 2022,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: [],
    certification: "Single",
    priceDigital: 1200,
    pricePhysical: 1400,
    tags: ["paint", "space"],
    publishing_data: "2022-08-10",
  },
  {
    id: 3,
    name: "City Lights",
    description: "Description of City Lights",
    artist: "Charlie Brown",
    year: 2018,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1400,
    pricePhysical: 1600,
    tags: ["nature", "photography", "city"],
    publishing_data: "2023-01-30",
  },
  {
    id: 4,
    name: "Abstract Reflections",
    description: "Description of Abstract Reflections",
    artist: "David White",
    year: 2023,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1600,
    pricePhysical: 1800,
    tags: ["history", "abstract"],
    publishing_data: "2020-11-15",
  },
  {
    id: 5,
    name: "Serenity",
    description: "Description of Serenity",
    artist: "Alice Johnson",
    year: 2022,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1500,
    pricePhysical: 1700,
    tags: ["ocean", "music", "abstract"],
    publishing_data: "2020-07-05",
  },
  {
    id: 6,
    name: "Mystic Forest",
    description: "Description of Mystic Forest",
    artist: "Olivia King",
    year: 2021,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1500,
    pricePhysical: 1700,
    tags: ["nature", "photography", "city"],
    publishing_data: "2020-10-12",
  },
  {
    id: 7,
    name: "Enchanted Lake",
    description: "Description of Enchanted Lake",
    artist: "Frank Wilson",
    year: 2019,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1100,
    pricePhysical: 1300,
    tags: ["nature", "music"],
    publishing_data: "2021-12-18",
  },
  {
    id: 8,
    name: "Celestial Harmony",
    description: "Description of Celestial Harmony",
    artist: "Grace Lee",
    year: 2021,
    type: ["Physical"],
    sizeDigital: ["1024x1400", "2048x2800"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1300,
    pricePhysical: 1500,
    tags: ["paint", "space"],
    publishing_data: "2022-02-25",
  },
  {
    id: 9,
    name: "Timeless Beauty",
    description: "Description of Timeless Beauty",
    artist: "Henry Martin",
    year: 2021,
    type: ["Physical"],
    sizeDigital: ["1024x1400", "2048x2800"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1300,
    pricePhysical: 1500,
    tags: ["nature", "history"],
    publishing_data: "2023-09-03",
  },
  {
    id: 10,
    name: "Cosmic Elegance",
    description: "Description of Cosmic Elegance",
    artist: "Isabel Adams",
    year: 2020,
    type: ["Physical"],
    sizeDigital: ["1024x1400", "2048x2800"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1100,
    pricePhysical: 1300,
    tags: ["paint", "space"],
    publishing_data: "2021-03-29",
  },
  {
    id: 11,
    name: "Mystical Mountains",
    description: "Description of Mystical Mountains",
    artist: "Olivia King",
    year: 2022,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1500,
    pricePhysical: 1700,
    tags: ["music", "abstract"],
    publishing_data: "2023-08-14",
  },
  {
    id: 12,
    name: "Ancient Ruins",
    description: "Description of Ancient Ruins",
    artist: "Katherine Clark",
    year: 2018,
    type: ["Digital", "Physical"],
    sizeDigital: ["1024x1400", "2048x2800"],
    sizePhysical: ["13cmx15cm", "16cmx19cm", "23cmx27cm"],
    certification: "Multiple",
    priceDigital: 1400,
    pricePhysical: 1600,
    tags: ["nature", "history", "ocean"],
    publishing_data: "2020-08-22",
  },
  {
    id: 13,
    name: "Urban Exploration",
    description: "Description of Urban Exploration",
    artist: "Liam Scott",
    year: 2019,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1100,
    pricePhysical: 1300,
    tags: ["photography", "city"],
    publishing_data: "2023-02-10",
  },
  {
    id: 14,
    name: "Vibrant Horizons",
    description: "Description of Vibrant Horizons",
    artist: "Mia Hall",
    year: 2020,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: [],
    certification: "Single",
    priceDigital: 1200,
    pricePhysical: 1400,
    tags: ["paint", "space"],
    publishing_data: "2022-04-25",
  },
  {
    id: 15,
    name: "Lunar Serenity",
    description: "Description of Lunar Serenity",
    artist: "Noah Harris",
    year: 2019,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1100,
    pricePhysical: 1300,
    tags: ["nature", "history"],
    publishing_data: "2021-11-05",
  },
  {
    id: 16,
    name: "Celestial Dreams",
    description: "Description of Celestial Dreams",
    artist: "Olivia King",
    year: 2020,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: [],
    certification: "Single",
    priceDigital: 1200,
    pricePhysical: 1400,
    tags: ["nature", "music"],
    publishing_data: "2021-06-28",
  },
  {
    id: 17,
    name: "Galactic Odyssey",
    description: "Description of Galactic Odyssey",
    artist: "Peter Roberts",
    year: 2021,
    type: ["Physical"],
    sizeDigital: ["1024x1400", "2048x2800"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1300,
    pricePhysical: 1500,
    tags: ["paint", "space"],
    publishing_data: "2022-10-17",
  },
  {
    id: 18,
    name: "Eternal Beauty",
    description: "Description of Eternal Beauty",
    artist: "Olivia King",
    year: 2019,
    type: ["Digital"],
    sizeDigital: ["1024x1400", "2048x2800", "4096x5600"],
    sizePhysical: ["13cmx15cm", "16cmx19cm"],
    certification: "Single",
    priceDigital: 1100,
    pricePhysical: 1300,
    tags: ["nature", "history"],
    publishing_data: "2023-03-02",
  },
];

const artistData = [
  {
    id: 1,
    firstName: "John",
    lastName: "Wick",
    biography: "John Doe is a talented artist known for his unique style...",
    ArtsID: [1, 3, 5],
  },
  {
    id: 2,
    firstName: "Albert",
    lastName: "Wesker",
    biography:
      "Jane Smith is a renowned artist with a passion for abstract art...",
    ArtsID: [2, 4],
  },
];

const about_section = [
  {
    name: <p>More About Funooni</p>,
    text: (
      <p>
        Funooni is a cutting-edge project by FunoonArab, designed to spotlight
        artists and their creativity, with a special focus on traditional Arabic
        art. Whether you're a painter, photographer, sculptor, designer, or
        content creator, Funooni provides a dynamic stage to showcase your
        talent, connect with your audience, collaborate with fellow artists, and
        share your work globally. Funooni is where innovation meets tradition,
        allowing artists to explore, thrive, and make their mark in the creative
        universe.
      </p>
    ),
  },
];

const boxes = [
  {
    img: ICO_BAZAR,
    title: "NFT Bazaar",
    content:
      "Where we transform valuable physical artworks into unique digital assets, secured and authenticated via blockchain. Here, you can buy and sell these exclusive digital pieces, expanding your collection and engaging with a community of art lovers.",
  },
  {
    img: ICO_TOKEN,
    title: "Tree Token",
    content:
      "Where you can support global reforestation and help sustain farming communities with our digital tokens that confirm your environmental impact.",
  },
  {
    img: ICO_ARTCHAIN,
    title: "ArtChain",
    content:
      "Where you can discover a selection of authenticated physical art pieces that cater to both contemporary and traditional tastes.",
  },
  {
    img: ICO_HUB,
    title: "Heritage Hub",
    content:
      "A platform dedicated to preserving and celebrating cultural arts through advanced digitization, ensuring that precious heritage from all across the world is safeguarded for future generations.",
  },
];
const servicesList = [
  {
    name: <>NFT Bazaar</>,
    img: ICO_BAZAR,
    description: (
      <>
        Where we transform valuable physical artworks into unique digital
        assets, secured and authenticated via blockchain. Here, you can buy and
        sell these exclusive digital pieces, expanding your collection and
        engaging with a community of art lovers.
      </>
    ),
  },
  {
    name: <>Tree Token</>,
    img: ICO_TOKEN,
    description: (
      <>
        Where you can support global reforestation and help sustain farming
        communities with our digital tokens that confirm your environmental
        impact.
      </>
    ),
  },
  {
    name: <>ArtChain</>,
    img: ICO_ARTCHAIN,
    description: (
      <>
        Where you can discover a selection of authenticated physical art pieces
        that cater to both contemporary and traditional tastes.
      </>
    ),
  },
  {
    name: <>Heritage Hub</>,
    img: ICO_HUB,
    description: (
      <>
        A platform dedicated to preserving and celebrating cultural arts through
        advanced digitization, ensuring that precious heritage from all across
        the world is safeguarded for future generations.
      </>
    ),
  },
];

const servDescription = {
  title: <p>Our Services</p>,
  desc1: (
    <p>
      At Funooni, we are dedicated to blending the realms of traditional and
      digital art. Here’s a look at the diverse services we offer:
    </p>
  ),
  desc2: (
    <p>
      Artists interested in transforming their physical artwork into digital art
      or NFTs are invited to reach out via <b>support@funoonarab.com</b> for
      personalized assistance in entering the digital art market. The team will
      then get back to the artists with more information on the process and
      costs involved.
    </p>
  ),
};

const textContainer = [
  {
    index: 3,
    title: <p>More About Funooni </p>,
    textContent: (
      <p>
        Funooni is a cutting-edge project by{" "}
        <a className="simpl_link" href="https://funoonarab.com/">
          FunoonArab
        </a>
        , designed to spotlight artists and their creativity, with a special
        focus on traditional Arabic art. Whether you're a painter, photographer,
        sculptor, designer, or content creator, Funooni provides a dynamic stage
        to showcase your talent, connect with your audience, collaborate with
        fellow artists, and share your work globally. Funooni is where
        innovation meets tradition, allowing artists to explore, thrive, and
        make their mark in the creative universe.
      </p>
    ),
  },
];

const teamMembers = [
  {
    name: "Raed Taha",
    role: "CEO & Director of Funooni",
    description:
      "Raed has over 25 years of experience in finance, ICT, and Fintech, Raed Taha has held senior roles at leading global companies, including Nour Smart Solutions and JP Morgan Chase Bank. A visionary leader, he excels in driving innovation, fostering business relationships, and delivering transformative solutions.",
  },
  {
    name: "Matvey Korovkin",
    role: "Senior Front Developer",
    description:
      "Matvey has over a decade of comprehensive experience in 3D design, programming, and game development to our team.  Skilled in a variety of software including Cinema 4D, Unreal Engine, and Adobe Suite, Matvey specializes in integrating complex 3D visualizations and interactive front-end designs that enhance user experiences on digital platforms.",
  },
  {
    name: "Ghazi Inaim",
    role: "Art Director",
    description:
      "Ghazi, has a Bachelor of Fine Arts from Damascus University and a PhD from the Global Initiative for Humanitarian Leadership, is a distinguished artist and cultural leader. He has served as President of the Jordanian Fine Artists Association and co-founded the Union of Arab Fine Artists, where he was elected Vice President. As the founder of Arab Fine Arts Magazine, Ghazi is also an active member of various writers' associations and editorial boards.",
  },
  {
    name: "Raghda Al-Shaikh Ali",
    role: "Front-end Developer",
    description:
      "Raghda Has over 4 years of experience in web development and quality assurance, where she applied best practices and industry standards to real-world projects and QA training. She has also earned certifications in front-end development (React.js) and back-end development (Node.js), enhancing her skills and driving her impactful contributions to Funooni.",
  },
  {
    name: "Rana El-Shaqra",
    role: "Digital Marketing Officer",
    description:
      "Rana has over 7 years of experience in digital marketing, administration, and project management, Rana has worked with diverse companies locally and globally. Specializing in business development, she excels in enhancing digital content, driving client engagement, and achieving results through strategic sales and communication.",
  },

  {
    name: "Alex Andaliev",
    role: "Python Developer",
    description:
      "Alex has more than 3 years of experience in developing various software. He has successfully implemented several large-scale projects, beginning with the development of scientific programs and subsequently transitioning to end-to-end development, including web applications and distributed systems.",
  },
];

const stepsData = [
  {
    image: MetaMask,
    title: "Create a MetaMask Wallet",
    content: (
      <>
        To start your journey, you’ll need a wallet; setting one up is easier
        than ever! You have two options:
      </>
    ),
    list: [
      "Download and install the MetaMask extension for your browser.",
      <a href="https://metamask.io" target="_blank">
        Get MetaMask <b>here</b>
      </a>,
    ],
  },
  {
    image: Link,
    title: "Connect Your Wallet",
    content: "Once your MetaMask wallet is ready:",
    list: [
      <p>
        Click the <b>Connect Wallet</b> button in the navigation bar.
      </p>,
      "Approve the connection request in MetaMask.",
      "After approval, your NFT account will be automatically created!",
    ],
  },
  {
    image: Research,
    title: "Explore NFTs",
    content: (
      <p>
        You're all set to experience the magic! Head to our <b>NFT Page</b> to
        discover and purchase stunning artwork.
      </p>
    ),
  },
];
const optionalInfo = [
  {
    title: "Alternative login",
    description: (
      <p>
        Use the burger menu to log in with your email, then connect MetaMask
        through your profile or the <b>Connect Wallet</b> button.
      </p>
    ),
  },
  {
    title: "Subscribe to news",
    description:
      "Visit your User Profile and connect your email to stay updated with the latest news and drops.",
  },
];
const FashionArtworks = [
  {
    id: 1,
    title: "Blending & Colors",
    artist: "Salah Shaheen",
    image: img5,
  },
  {
    id: 2,
    title: "Blending & Colors",

    artist: "Salah Shaheen",

    image: img3,
  },
  {
    id: 3,
    title: "Blending & Colors",

    artist: "Salah Shaheen",

    image: img1,
  },
  {
    id: 4,
    title: "Blending & Colors",

    artist: "Salah Shaheen",

    image: img4,
  },
];
const FashionProductsData = [
  { id: 1, image: img2, title: "T-shirt" },
  { id: 2, image: img3, title: "Hoodie" },
  { id: 3, image: img4, title: "Bag" },
];
const FashionFeaturesData = [
  {
    id: 1,
    icon: icon1,
    title: "Merge Fashion and Art",
    description:
      "Experience the perfect fusion of fashion and art. Select a masterpiece and bring it to life on your favorite clothing items like hoodies, t-shirts, or bags. More options coming soon!",
  },
  {
    id: 2,
    icon: icon2,
    title: "Design Your Unique NFT",
    description:
      "Unleash your creativity in our 3D editor. Customize your selected apparel with exclusive art, adjust placement, and personalize the design. Once complete, receive a one-of-a-kind NFT featuring your creation.",
  },
  {
    id: 3,
    icon: icon3,
    title: "Get Fashionable Cloth",
    description:
      "Turn your artistic vision into reality. Receive your custom-made clothing featuring a QR code linked to your NFT’s page, blending real-world fashion with digital innovation.",
  },
];
const FashionGalleryData = [
  { id: 1, image: img5, alt: "Art 1" },
  { id: 2, image: img6, alt: "Art 2" },
  { id: 3, image: img7, alt: "Art 3" },
  { id: 4, image: img1, alt: "Art 4" },
];

const hoodies = [
  {
    id: 1,
    image: hoodie_she,
    artwork: artwork,
    name: "Watermelon Maa'lish",
    artist: "Reham Shaheen",
    collection: "Watermelon Maa'lish",
    purchaseLink: "https://buy.stripe.com/3cseWRfGM2GK5mo03h",
    detailsLink: "https://funooni.com/nft/water_melon_maa'lish-13",
  },
  {
    id: 2,
    image: hoodie3,
    artwork: artwork6,
    name: "Horses series NFT Fashion",
    artist: "Aime Chamoun",
    collection: "Horses series NFT Fashion",
    purchaseLink: "https://buy.stripe.com/6oE6qldyE3KO8yA6rD",
    detailsLink: "https://funooni.com/nft/horse_2-14",
  },
  {
    id: 3,
    image: hoodie2,
    artwork: artwork3,
    name: "Rhythm of Nature and Art NFT Fashion",
    artist: "Aime Chamoun",
    collection: "Rhythm of Nature and Art NFT Fashion",
    purchaseLink: "https://buy.stripe.com/4gweWRfGM958168bLW",
    detailsLink: "https://funooni.com/nft/unrestricted_dialogue-15",
  },
  {
    id: 4,
    image: hoodie4,
    artwork: artwork5,
    name: "Water Melon Maa'lish NFT Fashion",
    artist: "Reham Shaheen",
    collection: "Water Melon Maa'lish NFT Fashion",
    purchaseLink: "https://buy.stripe.com/3cseWR0LSa9cg126rE",
    detailsLink: "https://funooni.com/nft/water_melon_maa'lish-13",
  },
  {
    id: 5,
    image: hoodie5,
    artwork: artwork4,
    name: "Van Cleef & Arpels and the Black Swan NFT Fashion",
    artist: "Aime Chamoun",
    collection: "Van Cleef & Arpels and the Black Swan NFT Fashion",
    purchaseLink: "https://buy.stripe.com/00g1612U0epscOQ17h",
    detailsLink: "https://funooni.com/nft/black_swan_-17",
  },
];

const tShirts = [
  {
    id: 6,
    image: t_shirt1,
    artwork: artwork5,
    name: "Water Melon Maa'lish NFT Fashion",
    artist: "Reham Shaheen",
    collection: "Water Melon Maa'lish NFT Fashion",
    purchaseLink: "https://buy.stripe.com/fZe2a52U0eps4ik5nC",
    detailsLink: "https://funooni.com/nft/water_melon_maa'lish-13",
  },
  {
    id: 7,
    image: t_shirt2,
    artwork: artwork2,
    name: "Olive Tree  NFT Fashion",
    artist: "Reham Shaheen",
    collection: "Olive Tree  NFT Fashion",
    purchaseLink: "https://buy.stripe.com/dR6aGB0LSa9c9CE17o",
    detailsLink:
      "https://funooni.com/nft/ma_baytlea_alzayt_ala_min_kutr_alesar-18",
  },
  {
    id: 8,
    image: t_shirt3,
    artwork: artwork,
    name: "Water Melon Maa'lish NFT Fashion",
    artist: "Reham Shaheen",
    collection: "Water Melon Maa'lish NFT Fashion",
    purchaseLink: "https://buy.stripe.com/fZe01X9ioeps7uw7vL",
    detailsLink: "https://funooni.com/nft/water_melon_maa'lish-13",
  },
];

export {
  optionalInfo,
  tShirts,
  hoodies,
  stepsData,
  teamMembers,
  artWorksData,
  artistData,
  servicesList,
  about_section,
  servDescription,
  textContainer,
  boxes,
  FashionArtworks,
  FashionProductsData,
  FashionFeaturesData,
  FashionGalleryData,
};